<div class="vincent_about2">
    <div class="row">
        <div class="col col-12 vincent_content">
            <div class="row vincent_reservation" style="flex-direction: row-reverse;">
                <div class="col col-12 vincent_reservation_block ">
                    <div class="relative-bottom">
                        <h3> .يتم تحضير طلبك</h3>
                        <h1 class="">كن دائما معنا</h1>
                        <img src="assets/imgs/separator_dark.png" alt="">
                        <p>تأكد من الرجوع لعمل طلبات جديد بعد أنتهاء تحضير و نزول أخر طلب قمت بعمله</p>
                        <div class="vincent_form_block">
                            <a class="vincent_button" routerLink='/'>العودة للرئيسية</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>